<style scoped lang="less">
.news-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    .news-data {
        padding-right: 30px;
        box-sizing: border-box;
        margin-top: 30px;
        font-size: 16px;
        width: 100%;
        word-break: break-all;
        .link {
            margin-top: 5px;
        }
    }
}
</style>

<template>
    <div class="news-container">
        <div class="news-data">
            <el-timeline class="news-item">
                <el-timeline-item v-for="(item, index) in data" :key="index" :timestamp="calcTime(item)" placement="top">
                    <div class="news-item-content">
                        {{item.remarks}}
                        <!-- <el-button class="super-mini-button margin-l">UGC</el-button>
                        <el-button class="super-mini-button  margin-l">STORY</el-button> -->
                    </div>
                </el-timeline-item>
            </el-timeline>
        </div>
    </div>
</template>

<script>
import { HttpClient } from "../util/http";
import { actionConfirm, msgError, msgSuccess } from "../util/toast";
import dayjs from "dayjs";

export default {
    components: {},
    mixins: [],
    data() {
        return {
            data: [],
        };
    },
    created() {
        this.fetchData();
    },
    computed: {},
    mounted() {
        console.log("====mounted====");
    },
    methods: {
        calcTime(item) {
            let diff = dayjs().diff(dayjs(item.createdAt), "minute");
            let content = "";
            let days = 0; //天
            let hours = 0; //小时
            let minutes = 0; //分钟
            if (diff >= 60 * 24) {
                days = Math.floor(diff / (60 * 24));
                diff -= days * 60 * 24;
            }
            if (diff >= 60) {
                hours = Math.floor(diff / 60);
                diff -= hours * 60;
            }
            minutes = diff;

            if (days > 0) content += days + "天";
            if (hours > 0) content += hours + "小时";
            if (minutes > 0) content += minutes + "分钟";
            if (content) content += "前";
            return dayjs(item.createdAt).format("M/D  HH:mm") + `　${content}`;
        },
        async fetchData() {
            console.log("====fetchData====");
            let cond = {};
            let res = await HttpClient.post("/restful", {
                model: "Suckle",
                cond,
                sort: {
                    _id: -1,
                },
                pageSize: 20,
                pageNum: 0,
                withCount: false,
            });
            this.data = res.result;

            //判断是否需要自动添加
            let isAdd = false;
            if (this.data.length) {
                let diff = dayjs().diff(
                    dayjs(this.data[0].createdAt),
                    "minute"
                );
                if (diff > 30) {
                    isAdd = true;
                }
            } else {
                isAdd = true;
            }
            if (isAdd) {
                await HttpClient.put("/restful", {
                    model: "Suckle",
                    cond: null,
                    updates: { remarks: "喂奶" },
                });
                await this.fetchData();
            }
        },
    },
};
</script>
